import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import { ApiService } from "../services/api.service";
import { map, tap } from "rxjs/operators";
import { MedicinService } from '../services';
// import { de } from 'date-fns/locale';

@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss']
})
export class DownloadAppComponent implements OnInit {


  constructor(public ApiService: ApiService, public ms: MedicinService) { }

  ngOnInit() {
    $('body').addClass('download-app');
    this.GetFaq();
  }
  ngOnDestroy() {
    $('body').removeClass('download-app');
  }

  sendmessageClass: any = "";
  sendmessageStatus: any = "";
  sendno: any = "";
  sendemailval: any = "";
  errormsgemail: any = "";
  sendemailStatus: any = false;
  emailsentclass: any = "";
  downloadLoader: any = false;
  loaderclass: any = '';
  getlinkLoader: any = false;
  getlinkLoaderclass: any = '';
  public faqData1: any = [];
  public faqData2: any = [];

  GetFaq() {
    this.ms.GetFaq().pipe(map(res => res.json()))
      .subscribe(data => {
        if (data.length > 0) {
          this.faqData1 = JSON.parse(data).slice(0, 2);
          this.faqData2 = JSON.parse(data).slice(2, 4);
          console.log(this.faqData1)
        }
        else {
          //error
        }
      });
  }

  removemsgerr(e) {
    this.sendmessageStatus = "";
    this.sendmessageClass = "";
    var val_old = e.target.value;
    var val = val_old.replace(/\D/g, "");
    var len = val.length;
    if (len >= 1) {
      val = "(" + val.substring(0);
    }
    if (len >= 3) {
      val = val.substring(0, 4) + ")" + "-" + val.substring(4);
    }
    if (len >= 6) {
      val = val.substring(0, 9) + "-" + val.substring(9);
    }
    if (val != val_old) {
      $(event.target)
        .focus()
        .val("")
        .val(val);
    }
  }
  sendmsg(val) {
    this.getlinkLoader = true;
    this.getlinkLoaderclass = 'loader-active';
    let mobUsPattern = "^(([0-9]{3}) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$";

    // 
    if (val != "" && val.length >= 7) {
      this.ApiService.sendSms(val)
        .pipe(
          tap(
            data => {

            },
            error => {

              let errorData = (this.sendmessageStatus = JSON.parse(
                error._body
              ));
              if (errorData.code == "21408") {
                this.sendmessageStatus = "Please enter a valid country code";
                this.sendmessageClass = "msgerror";
                this.getlinkLoader = false;
                this.getlinkLoaderclass = '';
              } else if (errorData.code == "21211") {
                this.sendmessageStatus = "Please enter a valid phone number";
                this.sendmessageClass = "msgerror";
                this.getlinkLoader = false;
                this.getlinkLoaderclass = '';
              } else {
                this.sendmessageStatus = "Please enter a valid phone number";
                this.sendmessageClass = "msgerror";
                this.getlinkLoader = false;
                this.getlinkLoaderclass = '';
              }
            }
          )
        )
        .subscribe(data => {

          this.sendmessageClass = "Success_sent";
          this.sendmessageStatus = "Message Sent";
          this.getlinkLoader = false;
          this.getlinkLoaderclass = '';
          setTimeout(() => {
            this.sendmessageClass = "";
            this.sendmessageStatus = "";
            this.sendno = "";
          }, 6000);
        });
    } else {

      this.sendmessageStatus = "Please enter a valid phone number";
      this.sendmessageClass = "msgerror";
      this.getlinkLoader = false;
      this.getlinkLoaderclass = '';
    }
  }

  sendemail(val) {
    this.downloadLoader = true;
    this.loaderclass = 'loader-active';
    var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.sendemailval != "" && this.sendemailval.match(mailformat)) {
      this.ApiService.senddownloadlinkToEmail(this.sendemailval)
        .subscribe(data => {
          ;
          if ((data[0].statuscode == 1)) {

            this.sendemailStatus = true;
            this.errormsgemail = "Email Sent!";
            this.emailsentclass = "successemailsent";
            this.downloadLoader = false;
            this.loaderclass = '';
            setTimeout(() => {
              this.sendemailStatus = false;
              this.errormsgemail = "";
              this.emailsentclass = "";
              this.sendemailval = ""
              this.loaderclass = '';
            }, 1000);
          }
          else {
            this.downloadLoader = false;
            this.loaderclass = '';
          }
        })
    } else if (this.sendemailval == "") {
      this.sendemailStatus = true;
      this.errormsgemail = "Please enter a valid email address";
      this.emailsentclass = "errorinemail";
      this.downloadLoader = false;
      this.loaderclass = '';
    }
    else {
      this.sendemailStatus = true;
      this.errormsgemail = "Invalid Email!";
      this.emailsentclass = "errorinemail";
      this.downloadLoader = false;
      this.loaderclass = '';
    }
    setTimeout(() => {
      $(".btn-loader").fadeOut("slow");
    }, 2000);
  }

  removemsgerremail(e) {
    this.sendemailStatus = false;
    this.errormsgemail = "";
    this.emailsentclass = "";
  }

}
